<!--
 * @Author: DESKTOP-6JOF46S\蔡洋杰 1760178806@qq.com
 * @Date: 2023-09-18 16:03:43
 * @LastEditors: DESKTOP-6JOF46S\蔡洋杰 1760178806@qq.com
 * @LastEditTime: 2023-10-23 09:57:04
 * @FilePath: \合联\vnlin-portal\src\view\workOrderManagement\list\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
    :footer="footer"
    ref="table"
  >
    <template #header>
      <Tabs v-model="tabName" @on-click="handleTab(0)">
        <TabPane
          v-for="tab in tabs"
          :label="tab.label"
          :key="tab.value"
          :name="tab.value + ''"
        />
      </Tabs>
    </template>
    <template #CHAT="{ params, visible }">
      <chat :data="params" v-if="visible" />
    </template>
  </cTable>
</template>

<script>
import cTable from "@/base/common/index";
import { apis } from "@/api/workOrderManagement/list";
import chat from "./chat.vue";
import { getAllService } from "@/api/user/internal";

export default {
  name: "workOrderList",
  components: {
    cTable,
    chat,
  },
  mounted() {
    getAllService().then((res) => {
      if (res.data.status) {
        console.log("res :>> ", res);
        let data = res.data.payload;
        this.header.searchs.forEach((t) => {
          if (t.key === "service_id") {
            t.options = [].concat(data[1], data[2], data[3], data[4]);
          }
        });
      }
    });
    apis.workStatus().then((res) => {
      console.log("res :>> ", res);
      if (res.data.status) this.tabs = res.data.payload;
    });
  },
  methods: {
    handleTab(state) {
      if (state) this.tabName1 = state;
      this.$refs["table"].resize();
      this.$refs["table"].getList(1);
      this.$refs["table"].getTable().recalculate(true);
    },
  },
  data() {
    return {
      methods: {
        ...apis,
        list: (p) => {
          p.status = this.tabName;
          return apis.list(p);
        },
      },
      tabs: [], // 工单状态
      tabName: "1",
      config: {},
      footer: {},
      modals: {
        upload: {
          methods: {
            ok() {
              window.open(
                this.$globalUrl +
                  "/doc/lang/work.xlsx".replace("lang", this.$i18n.locale)
              );
            },
          },
          footer: {
            cancel: {
              isShow: true,
            },
            ok: {
              name: this.$t("download_tem"),
            },
          },
          config: {
            modalBind: {
              width: 500,
              draggable: true,
              maskClosable: false,
            },
            rowBind: {
              gutter: 16,
              // style: {
              //   marginBottom: "20px"
              // }
            },
            title: this.$t("upload") + this.$t("files"),
          },
          grid: [{ files: 24 }],
          fields: [
            {
              key: "files",
              component: "Upload",
              bind: {
                type: "drag",
                accept: ".xlsx",
              },
              methods: {
                beforeUpload: ({ file }) => {
                  let _this = this.$refs["table"];
                  _this.handleRequestMethods("upload", { file }).then((res) => {
                    _this.$Message["success"]({
                      background: true,
                      content: res.msg,
                    });
                    _this.getModal("upload").close();
                  });
                  return false;
                },
              },
            },
          ],
        },
        reply: {
          type: "add",
          methods: {
            ok({ row, close }) {
              let data = this.handleFilterData({ id: row.id });
              this.$page
                .handleRequestMethods("reply", data, true, true)
                .then((res) => {
                  this.$page.getList();
                  close();
                });
            },
          },
          config: {
            title: this.$tz("回复"),
            modalBind: {
              width: 500,
            },
            formBind: {
              labelWidth: 100,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              describe: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                },
              ],
            },
          },
          grid: [{ describe: 24 }],
          fields: [
            {
              key: "describe",
              name: () => this.$tz("回复,内容"),
              placeholder() {
                return this.$tz("回复,内容");
              },
              component: "Input",
              bind: {
                type: "textarea",
                autosize: { minRows: 4 },
              },
            },
          ],
        },
        detail: {
          contentSlot: "CHAT",
          config: {
            title: this.$tz("详情"),
            modalBind: {
              width: 1000,
            },
            modalContentBind: {
              style: {
                height: "600px",
                padding: "0",
              },
            },
          },
          footer: {
            show: () => false,
          },
        },
      },
      header: {
        searchs: [
          {
            key: "startTime",
            placeholder() {
              return this.$tz("请选择,开始,日期");
            },
            component: "DatePicker",
            bind: {
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                },
              },
              style: {
                width: "150px",
              },
            },
          },
          {
            key: "endTime",
            placeholder() {
              return this.$tz("请选择,结束,日期");
            },
            component: "DatePicker",
            bind: {
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                },
              },
              style: {
                width: "150px",
              },
            },
          },
          {
            key: "client_id",
            placeholder() {
              return this.$tz("客户,名称");
            },
            component: "Select",
            options: [],
            optionsFn: "getAllClient",
            optionsKey: "",
          },
          {
            key: "service_id",
            placeholder() {
              return this.$tz("客服,名称");
            },
            component: "Select",
            options: [],
            optionsFn: "",
            optionsKey: "",
          },
          {
            key: "department",
            placeholder() {
              return this.$tz("部门");
            },
            component: "Select",
            options: [],
            optionsFn: "workDepartment",
            optionsKey: "",
          },
          {
            key: "has_annex",
            placeholder() {
              return this.$tz("是否,包含,附件");
            },
            component: "Select",
            options: [],
            optionsFn: "YesNo",
            optionsKey: "",
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input",
            bind: {
              type: "textarea",
              autosize: { minRows: 2, maxRows: 2 },
            },
          },
        ],
        btns: {
          list: [
            {
              name: () => this.$tz("导出"),
              type: "export",
              fnName: "export",
              bind: {
                type: "primary",
              },
              disabled() {
                return !this.selectAll.length;
              },
            },
            {
              name: () => this.$tz("完结,工单"),
              type: "complete",
              fnName: "complete",
              bind: {
                type: "primary",
              },
              id: 1859,
              disabled() {
                return !this.selectAll.length;
              },
            },
            {
              name: () => this.$tz("批量,回复"),
              type: "upload",
              fnName: "upload",
              bind: {
                type: "primary",
              },
              show: () => {
                return this.tabName != 3;
              },
              id: 1865,
            },
          ],
          methods: {
            export() {
              this.exportExc();
            },
            upload({ row }) {
              this.getModal("upload").open(row, function () {
                this.setTitle(this.$tz("批量,回复"));
              });
            },
            complete() {
              this.$Modal.confirm({
                title: this.$tz("完结,工单"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods(
                    "complete",
                    { ids: this.selectAll.map((t) => t.id) },
                    true,
                    true
                  ).then((res) => {
                    this.getList();
                  });
                },
              });
            },
          },
        },
      },
      fields: [
        {
          type: "checkbox",
          width: 50,
          align: "center",
        },
        {
          name: () => this.$tz("工单号"),
          key: "shipment_no",
          minWidth: 110,
        },
        {
          name: () => this.$tz("部门"),
          key: "department",
          minWidth: 110,
        },
        {
          name: () => this.$t("clientName"),
          key: "client_name",
          minWidth: 130,
        },
        {
          name: () => this.$t("Company name"),
          key: "company",
          minWidth: 130,
        },
        {
          name: () => this.$t("workOrderType"),
          key: "category_name",
          minWidth: 130,
        },
        {
          name: () => this.$t("Tracking number"),
          key: "airway_number",
          minWidth: 130,
        },
        {
          name: () => this.$tz("工单,描述"),
          key: "describe",
          minWidth: 130,
        },
        {
          name: () => this.$t("FollowPerson"),
          key: "service_name",
          minWidth: 130,
        },
        {
          name: () => this.$t("FollowTime"),
          key: "reply_time",
          minWidth: 130,
        },
        {
          name: () => this.$tz("工单,状态"),
          key: "status",
          minWidth: 130,
        },
        {
          name: () => this.$tz("创建时间"),
          key: "create_time",
          minWidth: 130,
        },
        {
          name: () => this.$t("operation"),
          type: "btns",
          width: 220,
          fixed: "right",
          list: [
            {
              name: this.$tz("消息"),
              type: "detail",
              fnName: "detail",
              bind: {
                type: "primary",
              },
              id: "",
            },
            // {
            //   name: this.$tz("回复"),
            //   type: "reply",
            //   fnName: "reply",
            //   bind: {
            //     type: "primary",
            //   },
            //   id: "",
            // },
          ],
          methods: {
            detail({ row }) {
              // this.handleRequestMethods(
              //   "detail",
              //   { id: row.id },
              //   true,
              //   false
              // ).then((res) => {
              this.getModal("detail").open(row, function () {
                this.setTitle(this.$tz("消息"));
                // this.list = res.payload;
              });
              // });
            },
            reply({ row }) {
              this.handleRequestMethods(
                "detail",
                { id: row.id },
                true,
                true
              ).then((res) => {
                this.getModal("reply").open({ id: row.id }, function () {
                  this.setTitle(this.$tz("回复"));
                  this.list = res.payload;
                });
              });
            },
          },
        },
      ],
    };
  },
};
</script>

<style scoped>
</style>